var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 11.35C2.66667 11.0946 2.86667 10.8857 3.11111 10.8857H4.88889C5.13333 10.8857 5.33333 11.0946 5.33333 11.35C5.33333 11.6053 5.13333 11.8143 4.88889 11.8143H3.11111C2.86667 11.8143 2.66667 11.6053 2.66667 11.35ZM6.22222 11.35C6.22222 11.0946 6.42222 10.8857 6.66667 10.8857H10.2222C10.4667 10.8857 10.6667 11.0946 10.6667 11.35C10.6667 11.6053 10.4667 11.8143 10.2222 11.8143H6.66667C6.42222 11.8143 6.22222 11.6053 6.22222 11.35ZM0 3.45712C0 2.43134 0.795833 1.59998 1.77778 1.59998H14.2222C15.2028 1.59998 16 2.43134 16 3.45712V12.7428C16 13.7672 15.2028 14.6 14.2222 14.6H1.77778C0.795833 14.6 0 13.7672 0 12.7428V3.45712ZM0.888889 3.45712V4.38569H15.1111V3.45712C15.1111 2.94437 14.7139 2.52855 14.2222 2.52855H1.77778C1.28694 2.52855 0.888889 2.94437 0.888889 3.45712ZM0.888889 7.1714H15.1111V5.31426H0.888889V7.1714ZM0.888889 8.09998V12.7428C0.888889 13.2564 1.28694 13.6714 1.77778 13.6714H14.2222C14.7139 13.6714 15.1111 13.2564 15.1111 12.7428V8.09998H0.888889Z",
    fill: "#149CE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.2ae5789e19e878f999f0ee3dcd150da8.svg";
export { ForwardRef as ReactComponent };